/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { lodash, propsUtils } from '@ba-ui-toolkit/utils';
import Button from '@ba-ui-toolkit/button';
import SVGIcon from '@ba-ui-toolkit/svgicon';
import chevronRight16 from '@ba-ui-toolkit/ba-graphics/dist/icons-js/chevron-right_16.js';
import styles from './SectionStyles.scss';
import PropertiesPane from '../PropertiesPane';

const linkSectionClassName = styles.linkSectionClassName.replace(/"/g, '');

const { uniqueId } = lodash;
const { sanitize, getInheritedProps } = propsUtils;

export default class LinkSection extends Component {
	static propTypes = {
		label: PropTypes.string.isRequired,
		value: PropTypes.string,
		labelSize: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
		title: PropTypes.string, // todo
		// currently title is used for the title of the link
		// we may need two titles - one for the property, and one for the link

		disabled: PropTypes.bool,
		rtl: PropTypes.bool,
		dataLabel: PropTypes.bool,
		onClick: PropTypes.func,
		className: PropTypes.string,
		style: PropTypes.object,
		...Button.propTypes,
		...PropertiesPane.propTypes,
	};

	static defaultProps = {
		className: '',
		style: {},
	};

	constructor(props) {
		super(props);
		this._id = uniqueId('__linkSection_');
		this._propLabelId = `${this._id}_propLabel_`;
	}

	render() {
		const {
			label,
			value,
			title,
			disabled,
			rtl,
			dataLabel,
			onClick,
			labelSize,
			className,
			style,
			...others
		} = this.props;

		const buttonIcon = {
			[rtl ? 'iconLeft' : 'iconRight']: rtl ? (
				<SVGIcon focusable={false} iconId={chevronRight16.id} rotate={180} />
			) : (
				<SVGIcon focusable={false} iconId={chevronRight16.id} />
			),
		};
		const buttonPassthroughProps = getInheritedProps(others, Button);
		const propertiesPanePassthroughProps = getInheritedProps(others, PropertiesPane);

		return (
			<PropertiesPane
				{...sanitize(others, LinkSection)}
				{...propertiesPanePassthroughProps}
				className={`${linkSectionClassName} ${className}`}
				label={label}
				rtl={rtl}
				disabled={disabled}
				htmlFor={this._id}
				labelSize={labelSize}
				labelId={this._propLabelId}
				dataLabel={dataLabel}
				style={style}
			>
				<Button
					role="link"
					data-tid="ba-common-link-section__button-link"
					aria-label={title}
					// {...buttonPassThroughProps}}// TODO: uncomment this line and remove next line when icon is deprecated
					{...sanitize(buttonPassthroughProps, null, 'icon')}
					{...buttonIcon}
					intent="primary"
					ellipsis
					id={this._id}
					variant="inline"
					label={value}
					disabled={disabled}
					onClick={onClick}
					title={title}
					aria-labelledby={title ? null : this._propLabelId}
				/>
			</PropertiesPane>
		);
	}
}
